module.exports = __webpack_public_path__ + "static/media/Icon3.15e9deb0.png";